// AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
// De klussen van een huishouden die nog bij geen enkele afspraak horen — wat
// de afspraakbewerker toont om ze alsnog bij díé afspraak in te plannen.

import { isSubtask } from './taskKind'

/**
 * @param {Array<object>|undefined} tasks - Taken van de organisatie (de gedeelde listener op het subtaak-soort volstaat)
 * @param {string} adressId - Het huishouden van de afspraak
 * @returns {Array<object>} Nog niet ingeplande subtaken van dat huishouden, op Position en dan op titel
 */
const unplannedSubtasksFor = (tasks, adressId) => {
    if (!adressId || !Array.isArray(tasks)) return []
    return tasks
        .filter((task) => isSubtask(task) && !task.Parent && task.AdressID === adressId && task.Deleted !== true)
        .sort((a, b) => ((a.Position ?? 0) - (b.Position ?? 0)) || String(a.Title || '').localeCompare(String(b.Title || ''), 'nl'))
}

export default unplannedSubtasksFor
